import { Component, Inject, ViewChild } from '@angular/core';
import { Customer } from '../../../models/customer/customer';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilterableTableComponent } from '../../ui/filterable-table/filterable-table.component';
import { TableView } from '../../ui/filterable-table/tableView';
import { CustomerTableViewComponent } from '../customer-table-view/customer-table-view.component';
import { StorageService } from '../../../core/storage/storageService';
import { Options } from '../../../components/ui/filterable-table/options';

@Component({
  selector: 'app-filter-customer-dialog',
  templateUrl: './filter-customer-dialog.component.html',
  standalone: false,
})
export class FilterCustomerDialogComponent {
  @ViewChild('customersTable') customersTable:
    | FilterableTableComponent
    | undefined;

  tableView: any;
  options: any;

  constructor(
    public dialogRef: MatDialogRef<FilterCustomerDialogComponent>,
    private storage: StorageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      merchantId: string;
    },
  ) {
    dialogRef.disableClose = false;

    this.options = new Options({
      filterable: true,
      allowEditing: false,
      merchantId: this.storage.getSelectedLocation()?.id,
    });
  }

  ngOnInit() {
    this.tableView = new TableView(CustomerTableViewComponent);
  }

  ngAfterViewInit() {}

  handleTableInitialized() {
    this.customersTable?.setOptions(this.options);
  }

  public async handleCustomerSelected(customer: Customer) {
    if (customer.id != undefined) {
      this.dialogRef.close(customer);
    }
  }
}
